<template>
  <div class="landing-hero-section">
    <div class="container">
      <div class="row" :class="{ 'headed-center': videoInHero }">
        <h1 v-if="options.titleHTML && videoInHero" class="h1 landing-title" v-html="options.titleHTML" />
        <div class="col hero-left" :class="[leftCols]">
          <div
            v-if="options.highlight" class="highlight" title="Get 65%OFF"
            v-html="options.highlight"
          />
          <div v-if="!videoInHero" class="heading">
            <h1 v-if="options.titleHTML" class="h1 landing-title" v-html="options.titleHTML" />
            <h2 v-else-if="options.titleH2" class="h2">
              {{ options.title }}
            </h2>
            <h1 v-else class="h1">
              {{ options.title }}
            </h1>
          </div>
          <slot name="text-decoration" />
          <slot name="mobile-promo-card" />
          <ul v-if="features.length" class="features">
            <li
              v-for="(feature, i) in features"
              :key="i"
              class="feature body-2"
            >
              {{ feature.name }}
            </li>
          </ul>
          <div v-if="options.subtitle" class="subtitle" v-html="options.subtitle" />
          <VideoPlayer
            v-if="options.subtitle && videoInHero && videoSource" slot="player" :video-id="videoSource"
            class="video-player"
          />
          <img v-if="options.image" :src="options.image" class="mobile-image">
          <div v-if="options.joinNote" class="join">
            <img src="../../assets/images/signup-users.png">
            <span>Join 2M+ Students</span>
          </div>
          <div v-if="options.companiesFooter" class="companies-footer">
            <hr>
            <div class="companies">
              <span class="h6">Trusted by employees from:</span>
              <div class="row logos">
                <div class="col col-4 sm-4">
                  <LogoOracle />
                </div>
                <div class="col col-4 sm-4">
                  <LogoAmazon />
                </div>
                <div class="col col-4 sm-4" />
                <div class="col col-4 sm-4">
                  <LogoWalmart />
                </div>
                <div class="col col-4 sm-4">
                  <LogoAzercell />
                </div>
                <div class="col col-4 sm-4">
                  <LogoVisa />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col hero-right" :class="[rightCols]">
          <PromoCard
            v-if="promoCardOptions"
            :options="promoCardOptions"
            :end-date="countdownEndDate"
            :save-label="saveLabel"
            :icons="showIcons"
            v-on="$listeners"
          />
          <img v-else-if="options.image" :src="options.image" class="desktop-image">
        </div>
      </div>
      <div v-if="options.companiesRow" class="row">
        <div class="hero-footer col col-12">
          <div class="hero-text">
            <span class="h6">
              Trusted by employees from:
            </span>
          </div>
          <div class="companies-logos">
            <div>
              <LogoBarclays v-if="$config.platform === 'fa'" class="logo-barclays" />
              <LogoOracle v-else class="logo-oracle" />
            </div>
            <div>
              <LogoBNP v-if="$config.platform === 'fa'" class="logo-bnp-paribas" />
              <LogoAmazon v-else class="logo-amazon" />
            </div>
            <div>
              <LogoJpMorgan v-if="$config.platform === 'fa'" class="logo-jp-morgan" />
              <LogoWalmart v-else class="logo-walmart" />
            </div>
            <div>
              <LogoGoldman v-if="$config.platform === 'fa'" class="logo-goldman-sacks" />
              <LogoVisa v-else class="logo-visa" />
            </div>
            <div>
              <LogoBankOfAmerica v-if="$config.platform === 'fa'" class="logo-bank-of-america" />
              <LogoAzercell v-else class="logo-azercell" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VideoPlayer from '@itbpbg/lms-components/src/components/VideoPlayer.vue';
import PromoCard from './PromoCard';
import LogoOracle from '../../assets/svg/logos/oracle.svg?vue-component';
import LogoAmazon from '../../assets/svg/logos/amazon.svg?vue-component';
import LogoWalmart from '../../assets/svg/logos/walmart.svg?vue-component';
import LogoVisa from '../../assets/svg/logos/visa.svg?vue-component';
import LogoAzercell from '../../assets/svg/logos/azercell.svg?vue-component';
import LogoBarclays from '../../assets/svg/companies/logo-barclays.svg?vue-component';
import LogoBNP from '../../assets/svg/companies/logo-bnp-paribas.svg?vue-component';
import LogoJpMorgan from '../../assets/svg/companies/logo-jp-morgan.svg?vue-component';
import LogoGoldman from '../../assets/svg/companies/logo-goldman-sacks.svg?vue-component';
import LogoBankOfAmerica from '../../assets/svg/companies/logo-bank-of-america.svg?vue-component';

export default {
  components: {
    VideoPlayer,
    PromoCard,
    LogoOracle,
    LogoAmazon,
    LogoWalmart,
    LogoVisa,
    LogoAzercell,
    LogoBarclays,
    LogoBNP,
    LogoJpMorgan,
    LogoGoldman,
    LogoBankOfAmerica,
  },
  props: {
    options: { type: Object, default: () => {}, required: true },
    features: { type: Array, default: () => [], required: false },
    promoCardOptions: { type: Object, default: () => {}, required: false },
    countdownEndDate: { type: Date, default: () => new Date(), required: false },
    saveLabel: { type: String, default: '', required: false },
    leftCols: { type: String, default: 'col-7', required: false },
    rightCols: { type: String, default: 'col-5', required: false },
    videoInHero: Boolean,
    videoSource: { type: String, default: '', required: false },
    showIcons: { type: Boolean, required: false },
  },
};
</script>

<style lang="scss">
.landing-hero-section {
  padding-top: var(--spacing-100);
  padding-bottom: var(--spacing-80);

  .row {
    > h1 {
      display: none;
    }

    .col-7 {
      .subtitle {
        display: block;
      }

      .video-player {
        display: none;
      }
    }

    .hero-right {
      padding-left: 65px;

      .card {
        padding: var(--spacing-36);

        .label-holder .label-accent {
          padding: var(--spacing-8) var(--spacing-16);
          display: inline-block;
          line-height: 100%;
          font-weight: 600;
        }

        .regular-price,
        .discounted-price {
          line-height: 110%;
        }

        .discounted-price {
          height: 74px;
        }

        .subtitle {
          margin-bottom: var(--spacing-20);
        }

        .countdown {
          height: 81px;
        }
      }
    }

    &.headed-center {
      > h1 {
        display: block;
        width: 100%;
        max-width: 50%;
        text-align: center;
        margin: 0 auto;
        margin-bottom: var(--spacing-40);
      }

      .col-7 {
        .heading,
        .subtitle {
          display: none;
        }

        .video-player {
          display: block;
        }
      }
    }
  }

  .highlight {
    font-size: 55px;
    letter-spacing: 0.015em;
    padding-top: 0;
    position: relative;
  }

  .heading {
    margin-bottom: var(--spacing-40);

    .landing-title {
      font-size: 43px;
    }
  }

  .features {
    display: grid;
    grid-template-columns: repeat(3, auto);
    column-gap: 46px;
    row-gap: 8px;
    margin-bottom: var(--spacing-32);
    padding-left: 0;
    list-style: none;

    .feature {
      background-image: url('../../assets/svg/icon-list-check.svg');
      image-rendering: -webkit-optimize-contrast;
      background-repeat: no-repeat;
      padding-left: var(--spacing-30);
    }
  }

  .subtitle {
    color: var(--main-light-shade-4);
  }

  .mobile-image {
    display: none;
    max-width: 100%;
  }

  .join {
    margin-top: var(--spacing-40);
    color: var(--main-light-shade-4);
    display: flex;
    align-items: center;

    img {
      padding-right: var(--spacing-20);
    }
  }

  .companies-footer {
    padding-top: var(--spacing-32);

    hr {
      height: 1px;
      border: none;
      background-color: var(--main-dark-shade-3);
      margin-bottom: 38px;
    }

    .companies {
      span {
        display: flex;
        align-items: center;
        color: var(--main-light-shade-4);
        margin: 0;
        padding-bottom: var(--spacing-12);
      }

      svg {
        max-width: 90px;
      }

      & path[fill] {
        fill: var(--main-light-shade-4);
      }
    }
  }

  .hero-footer {
    margin-top: 130px;
    padding: var(--spacing-28) 0 0;
    column-gap: 68px;
    row-gap: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;
    position: relative;
    color: var(--main-light-shade-3);
    z-index: 1;

    &:before {
      content: '';
      position: absolute;
      width: calc(100% - 30px);
      height: 1px;
      background: rgba(255, 255, 255, 0.12);
      top: 0;
      left: 50%;
      transform: translate(-50%);
    }

    .companies-logos {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-wrap: wrap;
      column-gap: 62px;
      row-gap: 8px;

      > div {
        height: 37px;

        .logo-oracle,
        .logo-amazon,
        .logo-visa,
        .logo-azercell {
          width: 120px;
        }

        .logo-walmart {
          width: 130px;
        }

        svg path[fill] {
          fill: var(--main-dark-light-4);
        }
      }
    }
  }
}

.fa {
  .landing-hero-section {
    .hero-footer {
      .companies-logos > div {
        .logo-barclays {
          width: 121px;
        }

        .logo-bnp-paribas {
          width: 132px;
        }

        .logo-jp-morgan {
          width: 117px;
        }

        .logo-goldman-sacks {
          width: 72px;
        }

        .logo-bank-of-america {
          width: 246px;
        }
      }
    }
  }
}

@include bp($bp-laptop) {
  .landing-hero-section {
    .row {
      .col-7 {
        .subtitle {
          line-height: 150%;
          font-size: 18px;
        }
      }

      .col-5 {
        padding-left: 45px;

        .card {
          padding: var(--spacing-36);

          .discounted-price {
            font-size: 60px;
          }

          .subtitle {
            margin-bottom: var(--spacing-20);
          }

          .countdown .square {
            p {
              font-size: 12px;
            }

            span {
              font-size: 32px;
            }
          }
        }
      }
    }

    .hero-footer {
      column-gap: 16px;

      .hero-text .h6 {
        font-size: 16px;
        font-weight: 400;
      }

      .companies-logos {
        column-gap: 50px;

        > div {
          height: 35px;

          .logo-oracle,
          .logo-amazon,
          .logo-visa,
          .logo-azercell {
            width: 111px;
          }

          .logo-walmart {
            width: 120px;
          }
        }
      }
    }
  }

  .fa {
    .landing-hero-section {
      .hero-footer {
        .companies-logos {
          column-gap: 30px;

          > div {
            .logo-barclays {
              width: 112px;
            }

            .logo-bnp-paribas {
              width: 122px;
            }

            .logo-jp-morgan {
              width: 108px;
            }

            .logo-goldman-sacks {
              width: 66px;
            }

            .logo-bank-of-america {
              width: 228px;
            }
          }
        }
      }
    }
  }
}

@include bp($bp-mobile) {
  .landing-hero-section {
    .row {
      > h1 {
        display: none;
      }

      .col-7 {
        .subtitle {
          display: block;
        }

        .video-player {
          display: none;
        }
      }

      .col-5 {
        .card {
          padding: var(--spacing-24);

          .btn-primary {
            max-width: 100%;
          }
        }
      }

      &.headed-center {
        > h1 {
          text-align: left;
          max-width: 100%;
        }

        .col-7 {
          .heading,
          .subtitle {
            display: none;
          }

          .video-player {
            display: block;
          }
        }
      }
    }

    .heading {
      .landing-title {
        br {
          display: none;
        }
      }
    }

    .mobile-image {
      display: block;
    }

    .desktop-image {
      display: none;
    }

    .features {
      grid-template-columns: 1fr;
    }

    .hero-footer {
      .col-2 {
        &:nth-of-type(2) {
          order: 1;
          max-width: 33%;
        }

        &:nth-of-type(3) {
          order: 5;
          max-width: 40%;
          margin-right: auto;
        }

        &:nth-of-type(4) {
          order: 2;
          max-width: 33%;
          margin: 0 auto;
        }

        &:nth-of-type(5) {
          order: 3;
          max-width: 33%;
        }

        &:nth-of-type(6) {
          order: 4;
          max-width: 40%;
          margin-left: auto;
        }

        svg {
          max-width: 90px;
        }
      }
    }
  }
}

@include bp($bp-phone) {
  .landing-hero-section {
    .row {
      .col-5 {
        .card {
          .discounted-price {
            height: 58px;
          }

          .countdown {
            height: 76px;
          }
        }
      }
    }

    .highlight {
      font-size: 43px;
    }

    .heading .h1 {
      font-size: 32px;
    }

    .features {
      &.list {
        margin-bottom: var(--spacing-24);
      }
    }

    .join {
      img {
        max-width: 120px;
      }

      span {
        font-size: 14px;
      }
    }

    .companies-footer {
      .companies .logos {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
      }
    }

    .hero-footer {
      .companies-logos {
        column-gap: 54px;

        > div {
          height: 28px;

          .logo-oracle,
          .logo-amazon,
          .logo-visa,
          .logo-azercell {
            width: 78px;
          }

          .logo-walmart {
            width: 92px;
          }
        }
      }
    }
  }
}
</style>
